import WasteServicePageLayout from "@/components/WasteServicePageLayout";
import { getWasteService } from "@/content/wasteServices";
import NotFound from "@/pages/NotFound";

const WasteServicePage = ({ slug }: { slug: string }) => {
  const service = getWasteService(slug);
  if (!service) return <NotFound />;
  return <WasteServicePageLayout service={service} />;
};

export default WasteServicePage;
